import { CLEAN_MERCADOPAGO, CLEAN_MERCADOPAGO_ERROR } from '_models/redux/types';

export const cleanMercadoPagoAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_MERCADOPAGO,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_MERCADOPAGO_ERROR,
    });
  }
};
